var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1123 15C29.1123 22.7304 22.8343 29 15.0864 29C7.33851 29 1.06055 22.7304 1.06055 15C1.06055 7.26964 7.33851 1 15.0864 1C22.8343 1 29.1123 7.26964 29.1123 15Z",
    fill: "white",
    stroke: "#E6E6E6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveStep);
export default __webpack_public_path__ + "static/media/inActiveStep.75a37ed4f78da082006af880a5509317.svg";
export { ForwardRef as ReactComponent };